import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { MultiSelect } from "react-multi-select-component";

import { add_theme, get_theme_categories_data, get_tag, update_theme, get_country_data, get_region_data } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './themesform.css';

export const ThemesForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData, capitalalizeFirstletter, updateStateAryData } = useContext(NewContext);
    const [themes, setThemes] = useState({
        id: state ? state._id : "",
        name: state ? state.name : "",
        themeCategory: state ? state.themeCategory : [],
        themeTag: state ? state.themeTag : [],
        country: state ? state.country : [],
        region: state ? state.region : [],
        isAnimated: state ? state.isAnimated == undefined ? false : state.isAnimated : false,
        isAvaiableDiffKey: state ? state.isAvaiableDiffKey == undefined ? false : state.isAvaiableDiffKey : false,
        isTop: state ? state.isTop == undefined ? false : state.isTop : false,
        isLatest: state ? state.isLatest == undefined ? false : state.isLatest : false,
        isHot: state ? state.isHot == undefined ? false : state.isHot : false,
        isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
        showStartDate: state ? state.showStartDate : "",
        showEndDate: state ? state.showEndDate : "",
    });
    const [imgObj, setImgObj] = useState({ smallPreviewTheme: state ? state.smallPreview : "", bigPreviewTheme: state ? state.bigPreview : "", themeZip: state ? state.themeZip : "" });
    const [category, setCategory] = useState([]);
    const [tag, setTag] = useState([]);
    const [country, setCountry] = useState([]);
    const [region, setRegion] = useState([]);

    const [multiThemeCategories, setMultiThemeCategories] = useState([]);
    const [multiThemeTags, setMultiThemeTags] = useState([]);
    const [multiThemeCountry, setMultiThemeCountry] = useState([]);
    const [multiThemeRegion, setMultiThemeRegion] = useState([]);


    // const capitalalizeFirstletter = (_str) => _str.charAt(0).toUpperCase() + _str.slice(1)
    // const updateStateAryData = (stateAry, fieldAllData, name) => {
    //     let blankAry = [];
    //     stateAry.map(_state => {
    //         let stateDefaultValue;
    //         if (name === 'country') {
    //             stateDefaultValue = fieldAllData.filter(_field_all => _field_all.code?.toLowerCase() === _state?.toLowerCase())[0];
    //         } else {
    //             stateDefaultValue = fieldAllData.filter(_field_all => _field_all.name.toLowerCase() === _state?.toLowerCase())[0];
    //         }
    //         blankAry.push(stateDefaultValue)
    //     })
    //     return blankAry.map(_ele => ({ value: name == 'country' ? _ele.code : _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: name }))
    // }

    const getCategoryAndTagFunc = async () => {
        try {
            const categoryData = await get_theme_categories_data(1, "", "", { isActive: true });
            const tagData = await get_tag(1, "", "", { isActive: true });
            const countryData = await get_country_data();
            const regionData = await get_region_data();
            if (categoryData.status && tagData.status && countryData.status && regionData.status) {
                // setCategory(categoryData.data);
                // setTag(tagData.data);
                // setCountry(countryData.data);
                // setRegion(regionData.data);
                // console.log(categoryData.data, '====categoryData');
                // console.log(tagData.data, '====tagData');

                categoryData.data.map(_ele => setCategory(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'themeCategory' }]))
                tagData.data.map(_ele => setTag(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'themeTag' }]))
                countryData.data.map(_ele => setCountry(_prev => [..._prev, { value: _ele.code, label: capitalalizeFirstletter(_ele.name), name: 'country' }]))
                regionData.data.map(_ele => setRegion(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'region' }]))

                if (state) {
                    let oldCategoryData = updateStateAryData(state?.themeCategory, categoryData.data, 'themeCategory');
                    let oldTagData = updateStateAryData(state?.themeTag, tagData.data, 'themeTag');
                    let oldCountryData = updateStateAryData(state?.country, countryData.data, 'country');
                    let oldRegionData = updateStateAryData(state?.region, regionData.data, 'region');
                    setMultiThemeCategories(oldCategoryData);
                    setMultiThemeTags(oldTagData);
                    setMultiThemeCountry(oldCountryData);
                    setMultiThemeRegion(oldRegionData);
                } else {
                    console.log(countryData.message || regionData.message);
                }
            } else {
                toast.error(categoryData.message || tagData.message);
            }
        } catch (error) {
            console.error(error);
        };
    };
    const handleChange = (e) => {
        if (e.target.name === 'themeCategory' || e.target.name === "themeTag" || e.target.name === "country" || e.target.name === "region") {
            let themeCategoryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
            setUpdatedData({ ...updatedData, [e.target.name]: themeCategoryAry })
            setThemes({ ...themes, [e.target.name]: themeCategoryAry });
        } else {
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
            setThemes({ ...themes, [e.target.name]: e.target.value });
        }
    };

    const handleSelectMultiThemeCategories = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'themeCategory') {
                    setMultiThemeCategories(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setThemes({ ...themes, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeCategories([]);
            setUpdatedData({ ...updatedData, themeCategory: [] })
            setThemes({ ...themes, themeCategory: [] });
        }
    }
    const handleSelectMultiThemeTags = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'themeTag') {
                    setMultiThemeTags(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setThemes({ ...themes, [_ele.name]: themeMultiSelectAry });
                }
            });
        } else {
            setMultiThemeTags([]);
            setUpdatedData({ ...updatedData, themeTag: [] })
            setThemes({ ...themes, themeTag: [] });
        }
    }
    const handleSelectMultiThemeCountry = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'country') {
                    setMultiThemeCountry(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setThemes({ ...themes, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeCountry([]);
            setUpdatedData({ ...updatedData, country: [] })
            setThemes({ ...themes, country: [] });
        }
    }
    const handleSelectMultiThemeRegion = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'region') {
                    // console.log(themeMultiSelectAry, '====>>>> region');
                    // console.log(e, '====>>>> region');
                    setMultiThemeRegion(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setThemes({ ...themes, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeRegion([]);
            setUpdatedData({ ...updatedData, region: [] })
            setThemes({ ...themes, region: [] });
        }
    }

    const handleFileInput = (e) => {
        // if (e.target.files[0]?.size > 5242880) {
        //     toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        // } else {
        setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
        setThemes({ ...themes, [e.target.name]: e.target.files[0] });
        // }
    };
    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: themes[e.target.name] ? false : true });
        setThemes({ ...themes, [e.target.name]: themes[e.target.name] ? false : true });
    };

    useEffect(() => {
        getCategoryAndTagFunc();
    }, []);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    const disablePastDate = () => {
        const today = new Date();
        const dd = String(today.getDate() + 0).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        return yyyy + "-" + mm + "-" + dd;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        }
        let createUpdateThemes;
        setIsLoading(true);
        if (state) {
            createUpdateThemes = await update_theme({ ...updatedData, themeCategory: themes.themeCategory, themeTag: themes.themeTag, country: themes.country, region: themes.region }, state._id)
        } else {
            // console.log("==========themes==========", themes);
            createUpdateThemes = await add_theme(themes)
        }
        setIsLoading(false);
        if (createUpdateThemes) {
            const { message, status } = createUpdateThemes;
            if (status) {
                toast.success(message);
                navigate("/themes");
                setThemes({
                    name: "",
                    themeTag: [],
                    themeCategory: [],
                    country: [],
                    region: [],
                    isAnimated: false,
                    isAvaiableDiffKey: false,
                    isTop: false,
                    isLatest: false,
                    isHot: false,
                    isPremium: false,
                    isActive: false,
                    showStartDate: "",
                    showEndDate: ""
                });
                setImgObj({ smallPreviewTheme: "", bigPreviewTheme: "", themeZip: "" });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }
    };
    // console.log(themes, '====themes');
    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Theme` : `Add Theme`}</h3>
            </div>
            <Row>
                <Col lg={4} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Small Preview : </h6>
                            <img className='w-100' src={`${imgObj.smallPreviewTheme ? imgObj.smallPreviewTheme : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : themes.name} />
                        </Col>
                        <Col>
                            <h6 className='mb-1'>Big Preview : </h6>
                            <img className='w-100' src={`${imgObj.bigPreviewTheme ? imgObj.bigPreviewTheme : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : themes.name} />
                        </Col>
                    </Row>
                </Col>
                <Col md={8} lg={8}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={12} className="mb-3">
                                <Form.Label htmlFor='theme_name' className='mb-1'>Name</Form.Label>
                                <Col><Form.Control id='theme_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : themes.name} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_themeCategory' className='mb-1'>Theme Category</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='themeCategory' onChange={handleChange} value={updatedData.themeCategory ? updatedData.themeCategory : themes.themeCategory} required>
                                        <option value={""} className='text-muted'>Select Categories</option>
                                        {category?.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        category && category.length > 0 &&
                                        <MultiSelect
                                            options={category}
                                            value={multiThemeCategories}
                                            onChange={handleSelectMultiThemeCategories}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_themeTag' className='mb-1'>Theme Tag</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='themeTag' onChange={handleChange} value={updatedData.themeTag ? updatedData.themeTag : themes.themeTag} required>
                                        <option value={""} className='text-muted'>Select Tags</option>
                                        {tag?.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        tag && tag.length > 0 &&
                                        <MultiSelect
                                            options={tag}
                                            value={multiThemeTags}
                                            onChange={handleSelectMultiThemeTags}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_country' className='mb-1'>Country</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='country' onChange={handleChange} value={updatedData.country ? updatedData.country : themes.country} required>
                                        <option value={""} className='text-muted'>Select Countries</option>
                                        {country?.map((_ele, i) => <option key={i} value={_ele.code}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        country && country.length > 0 &&
                                        <MultiSelect
                                            options={country}
                                            value={multiThemeCountry}
                                            onChange={handleSelectMultiThemeCountry}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_region' className='mb-1'>Region</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='region' onChange={handleChange} value={updatedData.region ? updatedData.region : themes.region} required>
                                        <option value={""} className='text-muted'>Select Regions</option>
                                        {region?.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        region && region.length > 0 &&
                                        <MultiSelect
                                            options={region}
                                            value={multiThemeRegion}
                                            onChange={handleSelectMultiThemeRegion}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_showStartDate' className='mb-1'>Start Date</Form.Label>
                                <Col><Form.Control id='theme_showStartDate' type="date" placeholder="Enter showStartDate" min={disablePastDate()} name='showStartDate' onChange={handleChange} value={updatedData.showStartDate ? updatedData.showStartDate?.split('T')[0] : themes.showStartDate?.split('T')[0]} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_showEndDate' className='mb-1'>End Date</Form.Label>
                                <Col><Form.Control id='theme_showEndDate' type="date" placeholder="Enter showEndDate" min={disablePastDate()} name='showEndDate' onChange={handleChange} value={updatedData.showEndDate ? updatedData.showEndDate?.split('T')[0] : themes.showEndDate?.split('T')[0]} required /></Col>
                            </Col>
                            <Col lg={4} className="mb-3">
                                <Form.Label htmlFor='theme_smallPreviewTheme'>Small Preview</Form.Label>
                                <Col><Form.Control id='theme_smallPreviewTheme' type="file" accept='image/*' name='smallPreviewTheme' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={4} className="mb-3">
                                <Form.Label htmlFor='theme_bigPreviewTheme' className='mb-1'>Big Preview</Form.Label>
                                <Col><Form.Control id='theme_bigPreviewTheme' type="file" accept='image/*' name='bigPreviewTheme' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={4} className="mb-3">
                                <Form.Label htmlFor='theme_themeZip' className='mb-1'>Theme Zip</Form.Label>
                                <Col><Form.Control id='theme_themeZip' type="file" accept='application/x-zip-compressed' name='themeZip' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isAnimated' className='mb-1'>Animated</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isAnimated" name='isAnimated' onChange={handleSwitch} checked={updatedData.isAnimated ? updatedData.isAnimated : themes.isAnimated} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isAvaiableDiffKey' className='mb-1'>Available Diff Key</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isAvaiableDiffKey" name='isAvaiableDiffKey' onChange={handleSwitch} checked={updatedData.isAvaiableDiffKey ? updatedData.isAvaiableDiffKey : themes.isAvaiableDiffKey} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isTop' className='mb-1'>Top</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isTop" name='isTop' onChange={handleSwitch} checked={updatedData.isTop ? updatedData.isTop : themes.isTop} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isLatest' className='mb-1'>Latest</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isLatest" name='isLatest' onChange={handleSwitch} checked={updatedData.isLatest ? updatedData.isLatest : themes.isLatest} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isHot' className='mb-1'>Hot</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isHot" name='isHot' onChange={handleSwitch} checked={updatedData.isHot ? updatedData.isHot : themes.isHot} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isPremium' className='mb-1'>Premium</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isPremium" name='isPremium' onChange={handleSwitch} checked={updatedData.isPremium ? updatedData.isPremium : themes.isPremium} role="button" /></Col>
                            </Col>
                            <Col xs={6} md={4} lg={3} className="mb-3">
                                <Form.Label htmlFor='theme_isActive' className='mb-1'>Active</Form.Label>
                                <Col><Form.Check type="switch" id="theme_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : themes.isActive} role="button" /></Col>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col className='d-flex flex-wrap justify-content-between justify-content-md-start'>
                                <Button variant="primary" type="submit" className='px-4 me-md-3'>
                                    {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                </Button>
                                <Button variant="danger" className='w-auto px-4' onClick={() => navigate(-1)}>{`Back`}</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

ThemesForm.defaultProps = {
    title: "Themes Form"
};

export default ThemesForm;